let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8tqgK"), load("d5ALI"), load("j2CBR"), load("9WWVF"), load("joJy8"), load("aHE9G"), load("6rkIt")]).then(() => parcelRequire('j2LbL'));